<div class="flex flex-wrap mt-4 min-w">
    <h1 class="w-full">Generación de imágenes ( ⚗️ 🧪 🧫 🔬)</h1>

    <h3 class="w-full">
        <p>
            Esta es una aplicación <strong>experimental</strong> que hemos incorporado en la plataforma para la
            generación de imágenes a partir de textos.
        </p>
        <p>
            Está basada en un afinamiento del modelo <em><u><a
                        href="https://en.wikipedia.org/wiki/Stable_Diffusion">Stable Diffusion</a></u></em> versión 1.5,
            con imágenes asociadas a tokens que le permite personalizar los
            resultados. Dicho modelo exige poder de cómputo por lo que en determinadas ocasiones va a notar cierta
            demora en obtener resultados por los procesos de carga en memoria del mismo.
        </p>
        <p>
            En el formulario debe especificar su token de CompAI y el <strong>texto en Inglés</strong> que describe la
            imagen que desea obtener. Es
            todo un arte la elección del texto descriptivo para poder obtener el resultado deseado. Les recomendamos que
            revisen <em><u><a href="https://lexica.art/">Lexica</a></u></em> para que observen los tipos de
            descripciones que se pueden
            proporcionar.
        </p>
        <p>
            A futuro iremos incorporando nuevas funcionalidades para poder ajustar parámetros que influirán en los
            resultados obtenidos.
        </p>
        <p>
            En caso de error en la carga del formulario, o de error durante el proceso de generación; le pedimos que se
            pongan en contacto con nosotros para el reporte del problema.
        </p>
    </h3>

    <h3 class="w-full">
        <table>
            <thead>
                <tr>
                    <th colspan="2">Ejemplo de imágenes generadas y sus descripciones</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Imagen</td>
                    <td>Descripción</td>
                </tr>
                <tr>
                    <td>
                        <img src="../../../../assets/img/image_generated_1.jpeg" style="width:100px; height: 100px;"
                            alt="img1">
                    </td>
                    <td>a detailed portrait of a helmet with the shape of an eagle</td>
                </tr>
                <tr>
                    <td>
                        <img src="../../../../assets/img/image_generated_2.jpeg" style="width:100px; height: 100px;"
                            alt="img2">
                    </td>
                    <td>a flat design icon of an african queen</td>
                </tr>
                <tr>
                    <td>
                        <img src="../../../../assets/img/image_generated_3.jpeg" style="width:100px; height: 100px;"
                            alt="img2">
                    </td>
                    <td>portrait of viking, cyborg, real life skin, intricate, elegant, highly detailed, artstation,
                        concept art, smooth, sharp focus, art by artgerm and greg rutkowski and alphonse mucha </td>
                </tr>
            </tbody>
        </table>
    </h3>

</div>


<div>
    <iframe id="frameID" title="Generación de imágenes" src="https://compai-image-generation.herokuapp.com"
        frameborder="0" width="850" height="1000"></iframe>
</div>
